import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CreateCompany } from '../components/CreateCompany';
import useManageCompany from '../hooks/useManageCompany';
import { ActionButtons } from '../../../components/others/ActionButtons';

export const LayoutCompanies = () => {
    const navigate = useNavigate();
    const {
        values,
        errorInputs,
        isEdit,
        countries,
        states,
        cities,
        handleInputChange,
        handleDirectInputChange,
        handleChangeCountryState,
        validForm,
        save,
        t
    } = useManageCompany();

    const handleSave = (e) => {
        const requiredFields = ["name", "id_number", "email", "supplier_tax_id", "supplier_additional_account_id",
            "supplier_tax_scheme", "supplier_tax_level_code"];
        if (!validForm(requiredFields, values))
            return false;

        save();
        handleCancel();
    };

    const handleCancel = () => navigate(-1);

    return (
        <Box sx={{ width: '100%', mx: 'auto' }} >
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <CreateCompany
                        values={values}
                        errorInputs={errorInputs}
                        isEdit={isEdit}
                        countries={countries}
                        states={states}
                        cities={cities}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        handleChangeCountryState={handleChangeCountryState}
                        t={t}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <Box sx={{ textAlign: 'right', mt: 4 }}>
                        <ActionButtons
                            onCancel={handleCancel}
                            onSubmit={handleSave}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};
